import classNames from 'classnames';
import React, { ButtonHTMLAttributes, FC } from 'react';
import styles from './IconButtonWrapper.module.scss';

export type FaPrefix = 'fas' | 'far' | 'fal' | 'fad' | 'fab';

export interface IIconButtonWrapper extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: string;
  iconPrefix?: FaPrefix;
  noMargin?: boolean;
}

const IconButtonWrapper: FC<IIconButtonWrapper> = (props) => {
  const { iconPrefix = 'fas', noMargin, icon, children, className, ...otherProps } = props;
  const rootClassName = classNames(styles.root, className);

  return (
    <button className={rootClassName} {...otherProps} type='button'>
      {icon && <span className={`${iconPrefix} fa-${icon}`} />}
      {children && (noMargin ? children : <span className='ml-2'>{children}</span>)}
    </button>
  );
};

export default IconButtonWrapper;
